import { collection, getDocs, query, where } from 'firebase/firestore';

export default async function getOnboardingDocs(db, dni) {
  try {
    const legajoRef = collection(db, `onboarding/${dni}/legajo`);
    const docsSnap = await getDocs(legajoRef);
    
    const documentos = [];
    docsSnap.forEach((doc) => {
      documentos.push({ 
        id: doc.id,
        ...doc.data(),
        origen: 'onboarding' // Para identificar el origen del documento
      });
    });
    
    return documentos;
  } catch (error) {
    console.error("Error al obtener documentos de onboarding:", error);
    return [];
  }
}